var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "offer-site" }, [
    _c("div", { staticClass: "offer-pdf__no-print row" }, [
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "m-portlet" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "form",
            { staticClass: "m-form m-form--fit m-form--label-align-right" },
            [
              _c("div", { staticClass: "m-portlet__body" }, [
                _c("div", { staticClass: "row mb-4" }, [
                  _c("div", { staticClass: "offset-3 col-9" }, [
                    _vm.offer.client
                      ? _c(
                          "div",
                          { staticClass: "m-card-user m-card-user--sm" },
                          [
                            _c("div", { staticClass: "m-card-user__pic" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "m-card-user__no-photo m--bg-fill-success",
                                  class: "m-badge--client-class-1"
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.offer.client.class))
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "m-card-user__details" }, [
                              _vm.offer.client.company != ""
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "m-card-user__name m--font-primary",
                                      staticStyle: { "max-width": "350px" }
                                    },
                                    [_vm._v(_vm._s(_vm.offer.client.company))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "m-card-user__name",
                                  staticStyle: { "max-width": "350px" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.offer.client.user.salutation) +
                                      " " +
                                      _vm._s(_vm.offer.client.user.pre_name) +
                                      " " +
                                      _vm._s(_vm.offer.client.user.name)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "m-card-user__name",
                                  staticStyle: { "max-width": "350px" }
                                },
                                [
                                  _c("small", [
                                    _c("i", { staticClass: "fa fa-at" }),
                                    _vm._v(
                                      " " + _vm._s(_vm.offer.client.user.email)
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.offer.client.phone != ""
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "m-card-user__name",
                                      staticStyle: { "white-space": "nowrap" }
                                    },
                                    [
                                      _c("small", [
                                        _c("i", { staticClass: "fa fa-phone" }),
                                        _vm._v(
                                          " " + _vm._s(_vm.offer.client.phone)
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "m-card-user__name" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "mt-4 btn btn-sm btn-brand",
                                    attrs: {
                                      href: "/kunde-" + _vm.offer.client.id,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("Zum Kunden")]
                                )
                              ])
                            ])
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "m-card-user m-card-user--sm" },
                          [
                            _c("div", { staticClass: "m-card-user__pic" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "m-card-user__no-photo m--bg-fill-success",
                                  class:
                                    "m-badge--client-class-" + _vm.offer.classId
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.offer.className))
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "m-card-user__details" }, [
                              _vm.offer.firma != ""
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "m-card-user__name m--font-primary",
                                      staticStyle: { "max-width": "350px" }
                                    },
                                    [_vm._v(_vm._s(_vm.offer.firma))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "m-card-user__name",
                                  staticStyle: { "max-width": "350px" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.offer.salutation) +
                                      " " +
                                      _vm._s(_vm.offer.pre_name) +
                                      " " +
                                      _vm._s(_vm.offer.name)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "m-card-user__name",
                                  staticStyle: { "max-width": "350px" }
                                },
                                [
                                  _c("small", [
                                    _c("i", { staticClass: "fa fa-at" }),
                                    _vm._v(" " + _vm._s(_vm.offer.email))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.offer.telefon != ""
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "m-card-user__name",
                                      staticStyle: { "white-space": "nowrap" }
                                    },
                                    [
                                      _c("small", [
                                        _c("i", { staticClass: "fa fa-phone" }),
                                        _vm._v(" " + _vm._s(_vm.offer.telefon))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-2" }, [
                  _c("div", { staticClass: "col-3 text-right" }, [
                    _vm._v("Produkttyp")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9" }, [
                    _vm._v(_vm._s(_vm.offer.produkttyp))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-2" }, [
                  _c("div", { staticClass: "col-3 text-right" }, [
                    _vm._v("Produkt")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9" }, [
                    _vm._v(_vm._s(_vm.offer.produkt))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-4" }, [
                  _c("div", { staticClass: "col-3 text-right" }, [
                    _vm._v("Anfrage")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9" }, [
                    _vm._v(_vm._s(_vm.offer.anfrage))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("label", { staticClass: "col-3 text-right" }, [
                      _vm._v("Projekttyp")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.projectTypeArr, function(type, key) {
                      return key == _vm.offerTemplate.project_type_id
                        ? _c("div", { staticClass: "col-9" }, [
                            _vm._v(_vm._s(type))
                          ])
                        : _vm._e()
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("label", { staticClass: "col-3 text-right" }, [
                    _vm._v("Projekt Vorlage")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9" }, [
                    _vm._v(_vm._s(_vm.offerTemplate.name))
                  ])
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "m-portlet mt-4" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "m-portlet__body" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-6 border-right" },
                _vm._l(_vm.employeeWorkload, function(employee) {
                  return employee.workload > 0
                    ? _c("div", { staticClass: "row mb-3" }, [
                        _c(
                          "div",
                          { staticClass: "col-3 d-flex align-items-center" },
                          [_vm._v(_vm._s(employee.name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-2 d-flex align-items-center" },
                          [_vm._v(_vm._s(employee.workload) + "h")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-5 d-flex align-items-center" },
                          [
                            _c("el-progress", {
                              staticClass: "w-100",
                              attrs: {
                                color: _vm.customColors,
                                "show-text": false,
                                percentage: employee.workloadPer
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-2 d-flex align-items-center" },
                          [_vm._v("80h")]
                        )
                      ])
                    : _vm._e()
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6" },
                _vm._l(_vm.kwWorkload, function(workload) {
                  return workload.workload > 0
                    ? _c("div", { staticClass: "row mb-3" }, [
                        _c(
                          "div",
                          { staticClass: "col-3 d-flex align-items-center" },
                          [_vm._v("KW " + _vm._s(workload.name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-2 d-flex align-items-center" },
                          [_vm._v(_vm._s(workload.workload) + "h")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-5 d-flex align-items-center" },
                          [
                            _c("el-progress", {
                              staticClass: "w-100",
                              attrs: {
                                color: _vm.customColors,
                                "show-text": false,
                                percentage: workload.workloadPer
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-2 d-flex align-items-center" },
                          [_vm._v("120h")]
                        )
                      ])
                    : _vm._e()
                }),
                0
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "m-portlet" }, [
          _vm._m(2),
          _vm._v(" "),
          _vm.offer.client
            ? _c("div", { staticClass: "m-portlet__body" })
            : _c(
                "div",
                { staticClass: "m-portlet__body" },
                [_c("client", { attrs: { offer: _vm.offer } })],
                1
              )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _c("div", {
          staticClass: "offer-pdf__container",
          domProps: { innerHTML: _vm._s(_vm.offer.offer_template_html) }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "offer-pdf__print text-center mt-4" },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "success",
                  disabled:
                    _vm.projectType === null || _vm.offerTemplate.name === null
                },
                on: {
                  click: function($event) {
                    return _vm.triggerPrint()
                  }
                }
              },
              [_vm._v("PDF drucken")]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head" }, [
      _c("div", { staticClass: "m-portlet__head-caption" }, [
        _c("div", { staticClass: "m-portlet__head-title" }, [
          _c("h3", { staticClass: "m-portlet__head-text" }, [
            _vm._v(
              "\n                                Anfrage\n                            "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head" }, [
      _c("div", { staticClass: "m-portlet__head-caption" }, [
        _c("div", { staticClass: "m-portlet__head-title" }, [
          _c("h3", { staticClass: "m-portlet__head-text" }, [
            _vm._v(
              "\n                                Auslastung & Mitarbeiter\n                            "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head" }, [
      _c("div", { staticClass: "m-portlet__head-caption" }, [
        _c("div", { staticClass: "m-portlet__head-title" }, [
          _c("h3", { staticClass: "m-portlet__head-text" }, [
            _vm._v(
              "\n                                Kunde anlegen\n                            "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }